import React, {PureComponent} from 'react';
import styled from 'styled-components';

const Container = styled.div`
    position: fixed;
    left: 0;
    top: 0;
    height: 100%;
    width: 100%;
    z-index: 100;

`;

const Wrapper = styled.div`
    position: relative;
    height: 100%;
    width: 100%;

    .rain {
        position: absolute;
        left: 0;
        width: 100%;
        height: 100%;
        z-index: 2;
    }

    .rain.back-row {
        display: none;
        z-index: 1;
        bottom: 60px;
        opacity: 0.5;
    }


    @keyframes drop {
        0% {
            transform: translateY(0vh);
        }
        75% {
            transform: translateY(90vh);
        }
        100% {
            transform: translateY(90vh);
        }
    }


    @keyframes stem {
        0% {
            opacity: 1;
        }
        65% {
            opacity: 1;
        }
        75% {
            opacity: 0;
        }
        100% {
            opacity: 0;
        }
    }


    @keyframes splat {
        0% {
            opacity: 1;
            transform: scale(0);
        }
        80% {
            opacity: 1;
            transform: scale(0);
        }
        90% {
            opacity: 0.5;
            transform: scale(1);
        }
        100% {
            opacity: 0;
            transform: scale(1.5);
        }
    }


`;

const Drop = styled.div`
    position: absolute;
    bottom: 100%;
    width: 15px;
    height: 120px;
    pointer-events: none;
    animation: drop 0.5s linear infinite;
`;

const Stem = styled.div`
    width: 1px;
    height: 60%;
    margin-left: 7px;
    background: linear-gradient(to bottom, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.25));
    animation: stem 0.5s linear infinite;

`;

const Splat = styled.div`
    width: 15px;
    height: 10px;
    border-top: 2px dotted rgba(0, 0, 0, 0.5);
    border-radius: 50%;
    opacity: 1;
    transform: scale(0);
    animation: splat 0.5s linear infinite;
    display: none;
`;


export default class Rain extends PureComponent {
    getDrops() {
        let increment = 0;
        // var drops = "";

        const drops = [];

        while (increment < 100) {
            //couple random numbers to use for various randomizations
            //random number between 98 and 1
            let randoHundo = (Math.floor(Math.random() * (98 - 1 + 1) + 1));
            //random number between 5 and 2
            let randoFiver = (Math.floor(Math.random() * (5 - 2 + 1) + 2));
            //increment
            increment += randoFiver;
            //add in a new raindrop with various randomizations to certain CSS properties

            const frontStyle = {
                left: `${increment}%`,
                bottom: `${randoFiver + randoFiver - 1 + 100}%`,
                'animationDelay': `0.${randoHundo}s`,
                'animationDuration': `0.5${randoHundo}s`,
            };

            const internalItemStyle = {
                'animationDelay': `0.${randoHundo}s`,
                'animationDuration': `0.5${randoHundo}s`,

            };

            drops.push(<Drop key={increment} style={frontStyle}>
                <Stem style={internalItemStyle}/>
                <Splat style={internalItemStyle}/>
            </Drop>);
        }

        return drops;
    }

    render() {
        return (
            <Container>
                <Wrapper>
                    <div className="rain front-row">
                        {this.getDrops()}
                    </div>
                    <div className="rain back-row"/>
                </Wrapper>
            </Container>)
    }
}
